/**
 * Telemedicine · Phase 1 · Lobby — generic mobile header.
 *
 * 56px-tall cream header with a centered title and a right-aligned close
 * button. Reusable across upcoming Phase B/C/D screens (Fatal, At-the-Meet,
 * Waiting) which share the same chrome per Figma.
 */
import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import CloseIcon from './CloseIcon';

interface LobbyHeaderProps {
  title: string;
  onClose: () => void;
  closeAccessibilityLabel?: string;
}

export default function LobbyHeader({
  title,
  onClose,
  closeAccessibilityLabel = 'Fechar',
}: LobbyHeaderProps) {
  return (
    <View style={styles.wrap}>
      <View style={styles.spacer} />
      <Text style={styles.title} numberOfLines={1}>
        {title}
      </Text>
      <TouchableOpacity
        style={styles.close}
        onPress={onClose}
        hitSlop={{ top: 16, bottom: 16, left: 16, right: 16 }}
        accessibilityRole="button"
        accessibilityLabel={closeAccessibilityLabel}
      >
        <CloseIcon />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 24,
    paddingVertical: 16,
    height: 56,
    backgroundColor: '#F9F8F3',
    // Android status-bar offset; iOS comes from SafeAreaView.
    marginTop: Platform.OS === 'android' ? 8 : 0,
  },
  spacer: { width: 24, height: 24 },
  title: {
    color: '#151515',
    fontFamily: 'Inter_700Bold',
    fontSize: 14,
    lineHeight: 14,
    textAlign: 'center',
    flex: 1,
  },
  close: {
    width: 24,
    height: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
